export default {
    translation: {
      // header
      SelectLanguage: "Выберите язык",
      Discover: "Открыть",
      WhyQriend: "Почему QRiend?",
      LeaveMark: "Оставь свой след",
      InstallNow: "Скачать сейчас",
      Login: "Войти",
      Register: "Регистрация",
      LogOut: "Выйти",
  
      // footer
      HomePage: "Главная",
      QriendDescFooter:
        "Открывайте новые дружеские связи в социальных средах, знакомьтесь безопасно и современно!",
      Pages: "Страницы",
      PrivacyAndSecurity: "Конфиденциальность и безопасность",
      QriendTeam: "Наша команда",
      PrivacyPolicy: "Политика конфиденциальности",
      TermsOfUse: "Условия использования",
      DataSecurity: "Безопасность данных",
      CookiePolicy: "Политика использования файлов cookie",
      AccountSecurity: "Безопасность аккаунта",
      LegalConsentAndDisclosureText: "Юридическое согласие и информационный текст",
      ChildSafetyPolicy: "Политика безопасности детей",
      PrivacySettingsGuide: "Политика настроек конфиденциальности",
      SuitableForAllDevices: "Совместимо со всеми устройствами",
      DownloadNowFooter: "Скачайте сейчас, расширьте свою социальную сеть!",
  
      // delete request
      DeleteRequestTitle: "Запрос на удаление аккаунта",
      DeleteAccountQuestion: "Вы хотите удалить свой аккаунт?",
      Username: "Имя пользователя",
      Password: "Пароль",
      DeleteReason: "Почему вы хотите удалить свой аккаунт?",
      UsernamePlaceholder: "Введите имя пользователя",
      PasswordPlaceholder: "Введите пароль",
      ReasonPlaceholder: "Объясните, почему вы хотите удалить аккаунт...",
      SubmitDeleteRequest: "Отправить запрос на удаление",
      Warning: "Предупреждение",
      WarningMessage: "Удаление аккаунта нельзя отменить. Все ваши данные будут удалены навсегда.",
      RequestSubmittedSuccessfully: "Запрос успешно отправлен",
      RequestSubmittedMessage: "Ваш запрос на удаление аккаунта получен. Мы свяжемся с вами в ближайшее время.",
      SendNewRequest: "Отправить новый запрос",
      UsernameRequired: "Имя пользователя обязательно",
      PasswordRequired: "Пароль обязателен",
      ReasonRequired: "Причина удаления аккаунта обязательна",
  
      // register page
      createAccount: "Создать аккаунт",
      createAccountDesc: "Зарегистрируйтесь сейчас и начните знакомиться с новыми людьми!",
      firstname: "Имя",
      lastname: "Фамилия",
      username: "Имя пользователя",
      email: "Электронная почта",
      password: "Пароль",
      gender: "Пол",
      male: "Мужской",
      female: "Женский",
      noGender: "Предпочитаю не указывать",
      registerMain: "Зарегистрироваться",
      registerDesc: "Уже есть аккаунт?",
      registerLogin: "Войти",
      kvkkConsent: "Я согласен с соглашениями KVKK и конфиденциальности",
      kvkkConsentRequired: "Вы должны согласиться с соглашениями KVKK и конфиденциальности",
      privacyPolicy: "Политика конфиденциальности",
      termsOfUse: "Условия использования",
  
      // Landing Qriend Nedir?
      WhatIsQriend: "Что такое QRiend?",
      WhatIsQriendDesc:
        "Позволяет вам знакомиться с людьми в том же месте с помощью QR-кода. Предлагает современную и безопасную платформу для знакомства с новыми людьми в социальных местах, таких как бары, кафе, рестораны.",
      RealProfile: "Реальный профиль",
      RealProfileDesc:
        "Вы взаимодействуете только с проверенными реальными пользователями.",
      InstantMeetingOpportunity: "Мгновенная возможность знакомства",
      InstantMeetingOpportunityDesc:
        "Вы можете мгновенно знакомиться с кем-то, кого видите в месте, отправив сообщение.",
      VenueChats: "Чаты заведений",
      VenueChatsDesc:
        "QRiend предлагает возможность цифрового общения в месте, где вы находитесь.",
  
      // Landing Nasıl Tanışılır?
      HowtoMeet: "Как знакомиться?",
      HowtoMeetDesc:
        "Благодаря нашему приложению знакомиться с людьми в том месте, где вы находитесь, в режиме реального времени теперь очень просто! Вот как использовать пошагово;",
      EntryandConnectiontotheSpace: "Вход и подключение к месту",
      EntryandConnectiontotheSpaceDesc: "Отсканируйте QR-код своим телефоном",
      EntryandConnectiontotheSpaceDesc2:
        "Войдите в приложение и присоединитесь к сети заведения",
      InSituExploration: "Исследование внутри места",
      InSituExplorationDesc: "Посмотрите других пользователей, которые сейчас находятся в заведении",
      InSituExplorationDesc2: "Изучите профили, которые кажутся вам интересными",
      CommunicationInitiation: "Начало общения",
      CommunicationInitiationDesc: "Отправьте сообщение людям, которые привлекли ваше внимание",
      CommunicationInitiationDesc2:
        "Легко общайтесь с кем-то, с кем встретились взглядом",
      CommunicationInitiationDesc3: "Войдите в групповой чат вашего местоположения",
      SafeSocialization: "Безопасное общение",
      SafeSocializationDesc: "Знакомьтесь, обмениваясь сообщениями",
      SafeSocializationDesc2:
        "Вы можете контролировать или завершить разговор в любое время",
      SafeSocializationDesc3:
        "Продолжайте знакомиться с новыми людьми приятно и безопасно",
  
      //   Uygulamayı İndir Bölümü
      DownloadApp: "СКАЧАТЬ ПРИЛОЖЕНИЕ &",
      DownloadApp2: "НАЧАТЬ ОТКРЫВАТЬ!",
      DownloadAppDesc: "В App Store и Google Play!",
      DownloadAppDesc2: "Скачайте бесплатно,",
      DownloadAppDesc3: "откройте премиум-функции.",
  
      // discover
      DiscoverTitle:
        "Инновационная и социальная платформа, упрощающая реальные встречи",
      DiscoverDesc:
        "Устали от бесконечных переписок? Хотели бы знать, что находитесь в том же месте с людьми, с которыми хотите познакомиться в реальной жизни? Именно поэтому наше приложение отличается!",
      DiscoverEp2:
        "Готовы ли вы получить возможность знакомиться с реальными людьми в том же месте, подтверждая свое присутствие с помощью QR-кода в наших партнерских заведениях?",
      DiscoverEp2Dot: "Отслеживание дружбы",
      DiscoverEp2DotDesc:
        "Следите за понравившимися профилями и открывайте заведения, которые они предпочитают. Получите возможность знакомства с новыми местами и новыми людьми.",
      DiscoverEp3Dot: "Лайки профилей и заведений",
      DiscoverEp3DotDesc:
        "Знакомьтесь с новыми людьми через понравившиеся профили и заведения, открывайте любимые места.",
      DiscoverEp4Dot: "Знакомство в заведении",
      DiscoverEp4DotDesc:
        "В отличие от обычных приложений для знакомств, у нас все реально! Вы можете видеть, что находитесь в том же месте с тем, кто вам нравится, и сразу знакомиться.",
      SwiperText: "Удобный интерфейс",
  
      SafetyMeet: "Более безопасные и веселые знакомства",
      RealTimeInteraction: "Взаимодействие в реальном времени",
      RealTimeInteractionDesc:
        "Вместо того чтобы теряться в виртуальном мире, знакомьтесь с людьми, которые действительно сейчас находятся в том же месте",
      RealTimeInteractionDesc2:
        "Кто в вашем любимом кафе? Посмотрите мгновенно и не упустите возможность знакомства",
      RealTimeInteractionDesc3:
        "Благодаря нашей QR-кодовой технологии легко подтвердите место, где вы находитесь",
      SecureAndVerifiedEnvironment: "Безопасная и проверенная среда",
      SecureAndVerifiedEnvironmentDesc: "Общайтесь в наших партнерских заведениях",
      SecureAndVerifiedEnvironmentDesc2:
        "Риск поддельных профилей минимален благодаря реальной проверке местоположения",
      SecureAndVerifiedEnvironmentDesc3:
        "Открывайте и делитесь любимыми заведениями",
      BenefitsForBusinesses: "Преимущества для бизнеса",
      BenefitsForBusinessesDesc: "Увеличьте поток клиентов",
      BenefitsForBusinessesDesc2: "Создайте среду с высоким социальным взаимодействием",
  
      // leave-mark
      LeaveMark: "Оставь свой след",
      LeaveMarkTitle:
        "Оставь свой след: расширь свой социальный опыт, создавай связи на мероприятиях",
      LeaveMarkDesc:
        "Функция 'Оставь свой след' QRiend позволяет расширить ваш социальный опыт на концертах, фестивалях, конференциях и многих других мероприятиях. Теперь вы можете знакомиться с новыми людьми не только в заведениях, но и на каждом мероприятии, которое посещаете.",
      How2Use: "Как это работает?",
      How2UseDot1: "Участие в мероприятии",
      How2UseDot1Desc:
        "Идите на концерт, фестиваль, конференцию или любое мероприятие",
      How2UseDot1Desc2: "Отсканируйте специальный QR-код QRiend в зоне мероприятия",
      How2UseDot1Desc3: "Мгновенно подключитесь к чату мероприятия",
      How2UseDot2: "Открытие участников мероприятия",
      How2UseDot2Desc:
        "Просмотрите других пользователей QRiend, участвующих в том же мероприятии",
      How2UseDot2Desc2:
        "Отслеживайте в реальном времени, сколько людей активно в чате мероприятия",
      How2UseDot2Desc3: "Найдите людей с общими интересами",
      How2UseDot3: "Особые взаимодействия",
      How2UseDot3Desc:
        "Вы можете отправлять специальные эмодзи участникам, которые привлекли ваше внимание",
      How2UseDot3Desc2:
        "Отправленные эмодзи видны во всем чате как 'Пользователь A отправил эмодзи сердца Пользователю B'",
      How2UseDot3Desc3:
        "Отправка эмодзи - это премиум-функция, которая делает знакомство на мероприятиях более веселым",
      WhereCanIUseIt: "Где я могу это использовать?",
      WhereCanIUseItDesc:
        "Самый простой способ знакомства с новыми людьми в разных средах от кафе до концертов, от фестивалей до ресторанов.",
      WhereCanIUseItDot1: "Оставь свой след на концертах",
      WhereCanIUseItDot1Desc:
        "Напишите что-то, что оставит ваш след на концерте, который вы посещаете.",
      WhereCanIUseItDot2: "Оставь свой след в кафе",
      WhereCanIUseItDot2Desc:
        "Возможность общения в широких дружеских кругах в кафе или пабах",
      WhereCanIUseItDot3: "Использование в барах и ночных клубах",
      WhereCanIUseItDot3Desc:
        "Общение в ночной жизни, тематические вечера и возможности безопасного знакомства",
      DownloadApp: "Скачайте мобильное приложение и оставьте свой след",
  
      // downloadPage
      DownloadNowNew: "Скачайте сейчас и начните",
      DownloadNowNew2: "знакомиться с новыми",
      DownloadNowNew3: "людьми!",
      DownloadNowDesc:
        "В каждом месте, куда вы идете, знакомьтесь с новыми людьми всего одним QR!",
      SupportPlatforms: "Поддерживаемые платформы и устройства",
      SupportPlatformsDesc: "Возможность доступа отовсюду",
      SupportPlatformsDesc2: "Мобильные устройства",
      SupportPlatformsDescDot:
        "Приложение для iOS (оптимизировано для iPhone и iPad)",
      SupportPlatformsDescDot2:
        "Приложение для Android (все телефоны и планшеты Android)",
  
      // login ve register
      welcome: "Добро пожаловать",
      welcomeDesc:
        "Мы скучали по вам! Пожалуйста, войдите в систему, чтобы наверстать упущенное.",
      email: "E-Mail",
      password: "Пароль",
      forgotPassword: "Забыли пароль?",
      login: "Войти",
      registerMain: "Регистрация",
      loginDesc: "У вас еще нет аккаунта? Сейчас же",
      loginReg: "зарегистрируйтесь",
      createAccount: "Создать аккаунт",
      createAccountDesc: "Зарегистрируйтесь сейчас, начните заводить новые дружеские связи.",
      firstname: "Имя",
      lastname: "Фамилия",
      username: "Имя пользователя",
      gender: "Пол",
      password: "Пароль (минимум 6 символов)",
      register: "Зарегистрироваться",
      registerDesc: "У вас есть аккаунт? Сейчас же",
      registerLogin: "Войти",
      rememberMe: "Запомнить меня",
      male: "Мужской",
      female: "Женский",
      noGender: "Не хочу указывать пол",
  
      // Şifre Sıfırlama - forgotPassword.js
      resetPassword: "Обновить пароль",
      resetPasswordDesc: "Пожалуйста, введите свой адрес электронной почты, чтобы запросить сброс пароля.",
      emailPlaceholder: "...@qriend.app",
      sending: "Отправка...",
      send: "Отправить",
      userNotFoundError: "Пользователь с этим адресом электронной почты не найден.",
      generalError: "Произошла ошибка, пожалуйста, попробуйте еще раз.",
      checkSpamFolder: "*Не забудьте проверить папку спам.",
  
      // Şifre Sıfırlama Onay - forgotPasswordConfirm.js
      passwordReset: "Сброс пароля",
      passwordResetDesc: "Введите 6-значный код, отправленный на ваш адрес электронной почты, и создайте новый пароль.",
      verificationCode: "Код подтверждения",
      codeValidityTime: "Срок действия кода",
      newPassword: "Новый пароль",
      newPasswordPlaceholder: "Введите новый пароль",
      confirmPassword: "Подтверждение пароля",
      confirmPasswordPlaceholder: "Подтвердите ваш пароль",
      resettingPassword: "Сброс пароля...",
      resetPasswordButton: "Сбросить пароль",
      enterVerificationCode: "Введите 6-значный код подтверждения.",
      passwordMinLength: "Пароль должен содержать не менее 6 символов.",
      passwordMismatch: "Пароли не совпадают!",
      passwordResetSuccess: "Ваш пароль был успешно сброшен!",
      passwordResetError: "Не удалось сбросить пароль, пожалуйста, попробуйте еще раз.",
    },
  };